import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { BlogsManagerStore } from './blogs-manager.store';


const BlogsManagerContext = React.createContext<BlogsManagerStore  | null>(null);

export const BlogsManagerProvider = ({ children }: { children: ReactNode }) => {
   const navigate = useNavigate();
   const [store] = React.useState< BlogsManagerStore >(() => new  BlogsManagerStore(navigate));

   return <BlogsManagerContext.Provider value={store}>{children}</BlogsManagerContext.Provider>;
};

export const useBlogsManager = () => {
   const ctx = React.useContext(BlogsManagerContext);
   if (!ctx) {
      throw new Error('useBlogsManager must be used inside BlogsManagerProvider');
   }
   return ctx;
};
